import { type UseQueryResult } from '@tanstack/react-query';

import { useApiQuery } from '../../../lib/api/hooks.js';
import { queryKeys } from '../../../lib/api/query-keys.js';
import { cancellationPolicyEndpoints } from './endpoints.js';
import { cancellationPolicyDetail, type CancellationPolicyDetail } from './schemas.js';

/**
 * Reads for the Cancellation Policies module.
 *
 * The list is not here: `ResourceListPage` owns list fetching so that search,
 * sort, filtering, pagination and column selection are implemented once rather
 * than per resource. A module supplies its endpoint, its row schema and its
 * filters, and the list page does the rest.
 */

export function useCancellationPolicyDetail(
  policyId: string,
): UseQueryResult<CancellationPolicyDetail> {
  return useApiQuery({
    queryKey: queryKeys.cancellationPolicies.detail(policyId),
    path: cancellationPolicyEndpoints.detail(policyId),
    schema: cancellationPolicyDetail,
  });
}
